<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/entities/auth'
import { useLoginDialog } from '@/shared/composables/useLoginDialog'
import { CButton } from '@/shared/ui'

const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()
const { openLoginDialog } = useLoginDialog()

function onTryForFree() {
  if (authStore.isAuthenticated) {
    router.push({ name: 'Tariffs' })
    return
  }
  openLoginDialog()
}
</script>

<template>
  <section
    class="container mx-auto text-center py-8 sm:py-12 md:py-16 lg:py-20 px-4 sm:px-6 lg:px-8"
  >
    <h1
      data-aos="fade-up"
      data-aos-duration="800"
      data-aos-delay="100"
      class="font-semibold text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[64px] text-[#172026] mb-4 sm:mb-6"
    >
      {{ t("landing_hero_title") }}
    </h1>
    <p
      data-aos="fade-up"
      data-aos-duration="800"
      data-aos-delay="200"
      class="text-base sm:text-lg text-[#172026] leading-6 sm:leading-7 md:leading-[28px] mb-6 sm:mb-8 md:mb-10"
    >
      {{ t("landing_hero_description") }}
    </p>

    <div
      data-aos="fade-up"
      data-aos-duration="800"
      data-aos-delay="300"
      class="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 md:gap-8 lg:gap-10 mb-12 sm:mb-16 md:mb-20"
    >
      <CButton
        type="primary"
        class="!px-6 sm:!px-8 !py-3 sm:!py-4 h-12 sm:h-14 md:h-[56px] text-lg sm:text-xl w-full sm:w-auto"
        @click="onTryForFree"
      >
        {{ t("try_for_free") }}
      </CButton>
      <a
        href="#dashboard-overview"
        class="!text-[#409EFF] !text-lg sm:!text-xl w-full sm:w-auto"
      >
        {{ t("unique_tools") }}
      </a>
    </div>

    <div
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay="400"
      class="hero-text rounded-xl sm:rounded-2xl py-8 sm:py-12 md:py-16 lg:py-[56px] px-6 sm:px-8 md:px-10"
    >
      <p
        class="text-white text-base sm:text-lg md:text-xl leading-[140%] sm:leading-[150%] md:leading-[160%] max-w-[1022px] mx-auto text-center"
      >
        {{ t("landing_hero_text") }}
      </p>
    </div>
  </section>
</template>

<style scoped>
.hero-text {
  background: linear-gradient(260deg, #7c1af8 3.61%, #eb3cca 98.57%);
}
</style>
